interface FinalPriceCalculationParams {
  isMultipleOption: boolean;
  first_order_discount?: number;
  final_price: number;
  promotion_quantity?: number | null;
}

export const makeFinalPrice = ({
  isMultipleOption,
  final_price,
  promotion_quantity,
  first_order_discount,
}: FinalPriceCalculationParams) => {
  const shouldApplyPromotion = isMultipleOption && promotion_quantity;

  const benefitFinalPrice = first_order_discount
    ? first_order_discount
    : shouldApplyPromotion
    ? final_price / (promotion_quantity + 1)
    : final_price;

  const membershipFinalPrice = shouldApplyPromotion ? final_price : null;

  return {
    benefitFinalPrice,
    membershipFinalPrice,
  };
};
